<script>
	import Board from './Board.svelte';
	import Puzzle from './Puzzle.svelte';
	import BufferSquare from './BufferSquare.svelte';
	import generateBoard from './BoardGenerator';
	import {checkProgressFromBuffer, generatePuzzles} from './Puzzle';

	let cashMoney = 10;
	let bufferCost = 4;
	let bufferSize = 4;
	let solutionsSize = 2;

	function newBuffer(size) {
		let buffer = [];

		for (let i = 0; i < size; i++) {
			buffer[i] = null;
		}

		return buffer;
	}
	
	let buffer = newBuffer(bufferSize);
	let otherCharacters = ['B1', 'C9', 'E2', 'AA', 'F8', 'DD', 'D1', 'BF', 'A0', 'B5', 'B6', '6B', '66', 'E0'];
	let characters = ['16', '12', 'E3', 'B2'];
	let puzzles = generatePuzzles(solutionsSize, characters, buffer.length);
		
	let boardSize = 5;
	let cssVars = `--size:${boardSize};`

	let board = generateBoard(boardSize, puzzles, characters);

	function addToBuffer(character) {
		let nextEmpty = buffer.indexOf(null);
		
		buffer[nextEmpty] = character;

		checkForProgress();
		checkForNewBoard();
	}

	function checkForProgress() {
		puzzles = puzzles.map((puzzle) => {
			puzzle = checkProgressFromBuffer(puzzle, buffer);

			if (puzzle.progress == puzzle.solution.length) {
				cashMoney += puzzle.reward.cash;

				if (puzzle.reward.bufferChange) {
					buffer[buffer.length] = null;
					bufferSize = bufferSize + puzzle.reward.bufferChange;
				}

				if (puzzle.reward.solutionChange) {
					solutionsSize = solutionsSize + puzzle.reward.solutionChange;
				}

				if (puzzle.reward.characterChange) {
					if (puzzle.reward.characterChange > 0 && otherCharacters.length > 0) {
						for (let i = 0; i < puzzle.reward.characterChange; i++) {
							characters.push(otherCharacters.pop());
						}
					} else if (puzzle.reward.characterChange < 0 && characters.length > 0) {
						for (let i = 0; i > puzzle.reward.characterChange; i--) {
							otherCharacters.push(characters.pop());
						}
					}
				}

				puzzle.status = 'solved';
			}

			return puzzle;
		});
	}
	
	function checkForNewBoard() {
		if (buffer.indexOf(null) < 0) {
			buffer = newBuffer(bufferSize);
			puzzles = generatePuzzles(solutionsSize, characters, buffer.length);
			board = generateBoard(boardSize, puzzles, characters);
			
			cashMoney -= bufferCost;
		}
    }
</script>

<style>
	.App {
		display: grid;

		grid-template-columns: 50% 50%;

		column-gap: 40px;
		row-gap: 40px;

		margin: 50px;
	}

	.matrix {
		border: 1px solid #d7f869;
	}

	.matrix>div {
		margin: 0 auto;
		width: calc(var(--size) * 50px);
		display: block;
	}

	.matrix h1 {
		background-color: #d7f869;

		color: #211e27;

		margin: 0;
		margin-bottom: 10px;
		padding: 10px;
	}

	.credit {
		position: absolute;

		bottom: 10px;
		right: 10px;

		font-size: 70%;
	}
</style>

<div class="App" style="{cssVars}">
	<div class="cash">
		<h1>Wallet</h1>
		<p>You have $€{cashMoney}. New buffers cost €${bufferCost}.</p>
	</div>

	<div class="buffer">
		<h1>Buffer</h1>

		{#each buffer as code}
			<BufferSquare {code} />
		{/each}
	</div>

	<div class="matrix">
		<h1>Code Matrix</h1>
		<div>
			<Board {board} {boardSize} {addToBuffer} />
		</div>
	</div>

	<div class="sequences">
		<h1>Sequences and rewards</h1>

		{#each puzzles as puzzle}
			<Puzzle {puzzle} />
		{/each}
	</div>

	<div class="credit"><a href="https://technicallyshane.com/">By Shane.</a> <a href="https://haikushane.itch.io/punked">Grab the source code.</a></div>
</div>